<footer class="brand-footer bg-dmp-green text-white text-sm text-center py-5 px-2.5 desktop:px-0">
  <div class="brand-footer__container max-w-lg mx-auto pb-5">
    <div class="brand-footer__links py-1">
      @for (link of links; track link.label; let last = $last) {
        <a href="{{ link.page }}" target="_blank" (click)="$event.preventDefault(); openLink(link.page)">{{ link.label }}</a>
        @if (!last) { <span> | </span> }
      }
    </div>
    <p class="brand-footer__disclaimer mt-3 px-4 desktop:px-0">{{ disclaimer }}</p>
    <p class="brand-footer__copyright mt-7">© {{ brand }} {{ year }}. All Rights Reserved.</p>
  </div>
</footer>
